/**
* BranchInfo defines model for branch object information
*
* @typedef BranchInfo
* @type {Object}
* @property {id} BranchId identifier
* @property {name} BranchName of current branch ( translated )
* @property {sortId} SortId sorting index of current branch
* @property {code} Code of current branch as string
*/
var BranchInfo = /** @class */ (function () {
    function BranchInfo(branchData) {
        this.id = branchData.id;
        this.name = branchData.name;
        this.sortId = branchData.sortId;
        this.code = branchData.code;
    }
    return BranchInfo;
}());
export { BranchInfo };
//# sourceMappingURL=BranchInfo.js.map